import RouterViewPage from '@/views/RouterViewPage.vue';
import ServiceProviders from '@/views/admin/advancedConfiguration/ServiceProviders.vue';
import Features from '@/views/admin/advancedConfiguration/Features.vue';
import VideoCategories from '@/views/admin/advancedConfiguration/VideoCategories.vue';
import Nodes from '@/views/admin/advancedConfiguration/nodes/Nodes.vue';
import Devices from '@/views/admin/advancedConfiguration/Devices/Devices.vue';
import AnalysisTypesTypes from '@/views/admin/advancedConfiguration/AnalysisTypeTypes/AnalysisTypeTypes';
import AdminLogs from '@/views/admin/advancedConfiguration/logs/AdminLogs.vue';
import Release from '@/views/admin/advancedConfiguration/Release.vue';
import GPTPublicUpload from '@/views/admin/advancedConfiguration/GPTPublicFileUpload.vue';
import AnalysisParamsUpload from '@/views/admin/advancedConfiguration/AnalysisParamsUpload.vue';
import DeviceAnalysisKeys from '@/views/admin/advancedConfiguration/deviceAnalysisKeys/DeviceAnalysisKeys.vue';
import md from '@/routes/middlewares';
import TermsOfUse from '@/views/admin/advancedConfiguration/TermsOfUse.vue';

const analysisParamsUpload = {
    path: 'analysisParamsUpload',
    name: 'analysisParamsUpload',
    component: AnalysisParamsUpload,
    meta: {
        middlewares: [
            md.isSuperAdmin,
        ],
    },
};

const advancedConfiguration = {
    path: 'advancedConfiguration',
    component: RouterViewPage,
    meta: {
        middlewares: [
            md.isAdmin,
        ],
    },
    children: [
        {
            path: 'serviceProviders',
            name: 'serviceProviders',
            component: ServiceProviders,
        },
        {
            path: 'clientcomponenttree',
            name: 'adminComponentTree',
        },
        {
            path: 'rolesprivileges',
            name: 'adminRolesPrivileges',
        },
        {
            path: 'erplinks',
            name: 'adminERPLinks',
        },
        {
            path: 'videoCategories',
            name: 'videoCategories',
            component: VideoCategories,
        },
        {
            path: 'nodes',
            name: 'nodes',
            component: Nodes,
        },
        {
            path: 'devices',
            name: 'devices',
            component: Devices,
        },
        {
            path: 'analysisTypeTypes',
            name: 'analysisTypeTypes',
            component: AnalysisTypesTypes,
        },
        {
            path: 'features',
            name: 'features',
            component: Features,
        },
        {
            path: 'logs',
            name: 'logs',
            component: AdminLogs,
        },
        {
            path: 'release',
            name: 'release',
            component: Release,
        },
        {
            path: 'termsOfUse',
            name: 'termsOfUse',
            component: TermsOfUse,
        },
        {
            path: 'publicGptConfig',
            name: 'publicGptConfig',
            component: GPTPublicUpload,
        },
        {
            path: 'deviceAnalysisKeys',
            name: 'deviceAnalysisKeys',
            component: DeviceAnalysisKeys,
        },
        analysisParamsUpload,
    ],
};

export default advancedConfiguration;
